import Phaser from 'phaser'
import {
    CST
} from '../CST'

export default class NamesScene extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.NAMES)
    }

    preload() {}

    create(data) {
        var clickSound = this.sound.add("clickSound");

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "main_background");

        var x = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        var y = this.cameras.main.worldView.y + this.cameras.main.height / 2;


        if (data.data == 2) {
            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 75, "yellow_name_box");
            var inputText = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2 - 75, 350, 50, {
                fontSize: "xx-large",
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });
            
            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 75, "green_name_box");
            var inputText2 = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2 + 75, 350, 50, {
                fontSize: "xx-large",
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });

            var start = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 250, "btn_next").setScale(.7);
            start.setInteractive({
                useHandCursor: true
            });
            start.on("pointerdown", () => {
                clickSound.play();
                if (inputText.text.length > 13 || inputText2.text.length > 13) {
                    var error = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "team_name_too_long");
                    inputText.setVisible(false);
                    inputText2.setVisible(false);

                    if (inputText.text.length > 13) {
                        inputText.setText("");
                    } else if (inputText2.text.length > 13) {
                        inputText2.setText("");
                    }

                    setTimeout(function () {
                        error.destroy();
                        inputText.setVisible(true);
                        inputText2.setVisible(true);
                    }, 2000)
                } else {
                    this.scene.start(CST.SCENES.BOARD2, {
                        data: [inputText.text, inputText2.text],
                        deck: data.deck,
                        replay: 1
                    }), this.scene.stop()
                }
            })
        } else if (data.data == 3) {
            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 150, "yellow_name_box");
            var inputText = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2 - 150, 350, 50, {
                fontSize: "xx-large",
                maxLength: 10,
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });

            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "green_name_box");
            var inputText2 = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2, 350, 50, {
                fontSize: "xx-large",
                maxLength: 10,
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });
            
            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 150, "red_name_box");
            var inputText3 = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2 + 150, 350, 50, {
                fontSize: "xx-large",
                maxLength: 10,
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });

            var start = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 350, "btn_next").setScale(.7);
            start.setInteractive({
                useHandCursor: true
            });
            start.on("pointerdown", () => {
                clickSound.play();
                if (inputText.text.length > 13 || inputText2.text.length > 13 || inputText3.text.length > 13) {
                    var array = new Array();
                    var error = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "team_name_too_long");
                    inputText.setVisible(false);
                    inputText2.setVisible(false);
                    inputText3.setVisible(false);

                    if (inputText.text.length > 13) {
                        inputText.setText("");
                    }
                    if (inputText2.text.length > 13) {
                        inputText2.setText("");
                    }
                    if (inputText3.text.length > 13) {
                        inputText3.setText("");
                    }

                    setTimeout(function () {
                        error.destroy();
                        inputText.setVisible(true);
                        inputText2.setVisible(true);
                        inputText3.setVisible(true);

                    }, 2000)
                } else {
                    this.scene.start(CST.SCENES.BOARD3, {
                        data: [inputText.text, inputText2.text, inputText3.text],
                        deck: data.deck,
                        replay: 1

                    }), this.scene.stop()
                }
            })
        } else if (data.data == 4) {
            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 175, "yellow_name_box");
            var inputText = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2 - 175, 350, 50, {
                fontSize: "xx-large",
                maxLength: 10,
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });

            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 50, "green_name_box");
            var inputText2 = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2 - 50, 350, 50, {
                fontSize: "xx-large",
                maxLength: 10,
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });

            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 75, "red_name_box");
            var inputText3 = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2 + 75, 350, 50, {
                fontSize: "xx-large",
                maxLength: 10,
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });

            this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 200, "purple_name_box");
            var inputText4 = this.add.rexInputText(this.cameras.main.width / 2 + 50, this.cameras.main.height / 2 + 200, 350, 50, {
                fontSize: "xx-large",
                maxLength: 10,
                backgroundColor: "#fff",
                color: "#000",
                placeholder: "Enter Team Name",
            });

            var start = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 350, "btn_next").setScale(.7);
            start.setInteractive({
                useHandCursor: true
            });
            start.on("pointerdown", () => {
                clickSound.play();

                if (inputText.text.length > 13 || inputText2.text.length > 13 || inputText3.text.length > 13 || inputText4.text.length > 13) {
                    var error = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "team_name_too_long");
                    inputText.setVisible(false);
                    inputText2.setVisible(false);
                    inputText3.setVisible(false);
                    inputText4.setVisible(false);

                    if (inputText.text.length > 13) {
                        inputText.setText("");
                    }
                    if (inputText2.text.length > 13) {
                        inputText2.setText("");
                    }
                    if (inputText3.text.length > 13) {
                        inputText3.setText("");
                    }
                    if (inputText4.text.length > 13) {
                        inputText4.setText("");
                    }

                    setTimeout(function () {
                        error.destroy();
                        inputText.setVisible(true);
                        inputText2.setVisible(true);
                        inputText3.setVisible(true);
                        inputText4.setVisible(true);

                    }, 2000)
                } else {
                    this.scene.start(CST.SCENES.BOARD4, {
                        data: [inputText.text, inputText2.text, inputText3.text, inputText4.text]
                    }), this.scene.stop()
                }
            })
        }
    }
}